import axios from "axios";

const API = axios.create({
  baseURL: "https://api.scoriva.net/api",
});

export const aboutTextApi = {
  get: () => API.get("/about-text"),
  update: (payload) => API.put("/about-text", payload),
};
